import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "ticketino-api-client";
import { useLanguage } from "../hooks/useLanguage";
import { useOrder } from "../hooks/useOrder";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import infoIcon from '../images/icons/info-red.svg';
import infoIconWhite from '../images/icons/info-white.svg';

// Import images for Raum Vis a Vis
import raumVisAVisImg from '../images/addons/addon-vis-a-vis.png'; // Replace with actual image path

// Centralized add-ons config for each booking type
const AddOnsConfigs = {
    groupvisit: {
        TicketsQuantitylimitToDisplay: 36,
        tour: {
            quantity: 1,
            priceDE12: 210.00,
            priceEN12: 240.00,
            priceFR12: 240.00,
            priceDE24: 310.00,
            priceEN24: 340.00,
            priceFR24: 340.00,
            priceDE36: 410.00,
            priceEN36: 440.00,
            priceFR36: 440.00,
            externalTicketCodeDE12: "group addon tour de 12",
            externalTicketCodeEN12: "group addon tour en 12",
            externalTicketCodeFR12: "group addon tour fr 12",
            externalTicketCodeDE24: "group addon tour de 24",
            externalTicketCodeEN24: "group addon tour en 24",
            externalTicketCodeFR24: "group addon tour fr 24",
            externalTicketCodeDE36: "group addon tour de 36",
            externalTicketCodeEN36: "group addon tour en 36",
            externalTicketCodeFR36: "group addon tour fr 36",
        },
        WOWIntro: {
            quantity: 1,
            priceDE12: 110.00,
            priceEN12: 140.00,
            priceFR12: 140.00,
            priceDE24: 200.00,
            priceEN24: 230.00,
            priceFR24: 230.00,
            priceDE36: 290.00,
            priceEN36: 320.00,
            priceFR36: 320.00,
            externalTicketCodeDE12: "group addon intro de 12",
            externalTicketCodeEN12: "group addon intro en 12",
            externalTicketCodeFR12: "group addon intro fr 12",
            externalTicketCodeDE24: "group addon intro de 24",
            externalTicketCodeEN24: "group addon intro en 24",
            externalTicketCodeFR24: "group addon intro fr 24",
            externalTicketCodeDE36: "group addon intro de 36",
            externalTicketCodeEN36: "group addon intro en 36",
            externalTicketCodeFR36: "group addon intro fr 36",
        },
        visitorSupport: {
            quantity: 2,
            price: 80.00,
            externalTicketCode: "group addon host",
            TicketsQuantityNeededToDisplay: 37,
        },
        addGuide: {
            quantity: 3,
            externalTicketCode: "addon add a guide",
        },
        raumVisAVis: {
            TicketsQuantitylimitToDisplay: 20,
            options: [
                {
                    label: "Kurzmiete",
                    price: 150.00,
                    externalTicketCode: "bday addon raum kurzmiete"
                },
                {
                    label: "Halbtagesmiete",
                    price: 260.00,
                    externalTicketCode: "bday addon raum halbtagesmiete"
                },
                {
                    label: "Ganztagesmiete",
                    price: 450.00,
                    externalTicketCode: "bday addon raum ganztagesmiete"
                }
            ],
            image: raumVisAVisImg,
        },
    },
    schoolgroup: {
        TicketsQuantitylimitToDisplay: 37,
        tour: {
            quantity: 1,
            priceDE12: 168.00,
            priceEN12: 198.00,
            priceFR12: 198.00,
            priceDE24: 248.00,
            priceEN24: 278.00,
            priceFR24: 278.00,
            priceDE36: 328.00,
            priceEN36: 358.00,
            priceFR36: 358.00,
            externalTicketCodeDE12: "school addon tour de 12",
            externalTicketCodeEN12: "school addon tour en 12",
            externalTicketCodeFR12: "school addon tour fr 12",
            externalTicketCodeDE24: "school addon tour de 24",
            externalTicketCodeEN24: "school addon tour en 24",
            externalTicketCodeFR24: "school addon tour fr 24",
            externalTicketCodeDE36: "school addon tour de 36",
            externalTicketCodeEN36: "school addon tour en 36",
            externalTicketCodeFR36: "school addon tour fr 36",
        },
        WOWIntro: {
            quantity: 1,
            priceDE12: 88.00,
            priceEN12: 118.00,
            priceFR12: 118.00,
            priceDE24: 160.00,
            priceEN24: 190.00,
            priceFR24: 190.00,
            priceDE36: 232.00,
            priceEN36: 262.00,
            priceFR36: 262.00,
            externalTicketCodeDE12: "school addon intro de 12",
            externalTicketCodeEN12: "school addon intro en 12",
            externalTicketCodeFR12: "school addon intro fr 12",
            externalTicketCodeDE24: "school addon intro de 24",
            externalTicketCodeEN24: "school addon intro en 24",
            externalTicketCodeFR24: "school addon intro fr 24",
            externalTicketCodeDE36: "school addon intro de 36",
            externalTicketCodeEN36: "school addon intro en 36",
            externalTicketCodeFR36: "school addon intro fr 36",
        },
        visitorSupport: {
            quantity: 2,
            price: 80.00,
            externalTicketCode: "group addon host",
            TicketsQuantityNeededToDisplay: 37,
        },
        addGuide: {
            quantity: 3,
            externalTicketCode: "addon add a guide",
        },
        raumVisAVis: {
            TicketsQuantitylimitToDisplay: 20,
            options: [
                {
                    label: "Kurzmiete",
                    price: 150.00,
                    externalTicketCode: "bday addon raum kurzmiete"
                },
                {
                    label: "Halbtagesmiete",
                    price: 260.00,
                    externalTicketCode: "bday addon raum halbtagesmiete"
                },
                {
                    label: "Ganztagesmiete",
                    price: 450.00,
                    externalTicketCode: "bday addon raum ganztagesmiete"
                }
            ],
            image: raumVisAVisImg,
        },
    },
};

// Utility to get the correct config suffix based on total booked tickets
function getSuffix(total, isHost) {
    if (total <= 12) return "12"; // up to 12
    if (total <= 24) return "24"; // 13-24
    if (total <= 36) return "36"; // 25-36

    if (isHost) {
        return "Host"; // groupvisit bookingType + 37+
    }

    return "36" // fallback 36
}

const Addons = () => {
    const [resources, setResources] = useState({});
    const [selectedAddon, setSelectedAddon] = useState("");

    // State for selected language in dropdowns
    const [tourLanguageSelected, setTourLanguageSelected] = useState("");
    const [wowIntroLanguageSelected, setWowIntroLanguageSelected] = useState("");

    // State for visitor support quantity
    const [visitorSupportQuantity, setVisitorSupportQuantity] = useState(0);

    // State for add guide quantity
    const [addGuideQuantity, setAddGuideQuantity] = useState(0);

    const [errorMsg, setErrorMsg] = useState("");

    // State for kombi-ticket checkbox selection
    const [kombiTicketSelected, setKombiTicketSelected] = useState(false);

    // State for Raum Vis a Vis dropdown selection
    const [raumVisAVisSelected, setRaumVisAVisSelected] = useState("");

    // Booking type (groupvisit, schoolgroup, etc.)
    const [bookingType, setBookingType] = useState(null);

    // Get selected tickets from localStorage
    const selectedTickets = JSON.parse(localStorage.getItem('selectedTickets'));
    const selectedTicketsCrossSelling = JSON.parse(localStorage.getItem('selectedTicketsCrossSelling'));

    // Calculate total number of booked tickets
    const totalBookedTickets = selectedTickets?.tickets?.reduce((sum, t) => sum + (t.quantity || 0), 0) || 0;

    let navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const { language } = useLanguage();
    const order = useOrder(baseUrl);

    // Host - only for groupvist and more than 36 tickets selected
    const isHost = bookingType === "groupvisit" && totalBookedTickets >= 37;

    // Select the correct config for the current booking type
    // Fallback to groupvisit if bookingType is not set
    const activeConfig = AddOnsConfigs[bookingType] || AddOnsConfigs.groupvisit;
    // Get the correct suffix for ticket code/price based on totalBookedTickets
    const suffix = getSuffix(totalBookedTickets, isHost);

    useEffect(() => {
        document.body.classList.remove('no-scroll');
        setBookingType(localStorage.getItem("bookingType"));
    }, []);

    useEffect(() => {
        if (language) {
            requestResources();
        }
    }, [language]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    // Set default dropdown selection for language when config or suffix changes
    useEffect(() => {
        if (activeConfig) {
            setTourLanguageSelected(activeConfig.tour[`externalTicketCodeDE${suffix}`]);
            setWowIntroLanguageSelected(activeConfig.WOWIntro[`externalTicketCodeDE${suffix}`]);
        }
    }, [activeConfig, suffix]);

    // Handler for radio button selection
    const handleAddonChange = (value) => {
        setSelectedAddon(value);
        setErrorMsg("");
    };

    // Handler for tour language dropdown
    const handleTourLanguageDropdown = (lang) => {
        setTourLanguageSelected(lang);
    };

    // Handler for WOWIntro language dropdown
    const handleWowIntroLanguageDropdown = (lang) => {
        setWowIntroLanguageSelected(lang);
    };

    // Handler for Kombi-ticket checkbox
    const handleKombiTicketCheckbox = () => {
        setKombiTicketSelected(!kombiTicketSelected);
    };

    // Handler for Raum Vis a Vis dropdown
    const handleRaumVisAVisDropdown = (value) => {
        setRaumVisAVisSelected(value);
    };

    // Handler for Next button
    // Prepares selected add-on ticket and saves to localStorage
    const handleNext = () => {
        // Check if tour options are available
        const showTourOptions = totalBookedTickets <= activeConfig.TicketsQuantitylimitToDisplay && !isHost;

        // Only require addon selection if tour options are available
        if (showTourOptions && !selectedAddon && visitorSupportQuantity === 0) {
            setErrorMsg(resources?._ErrorPleaseChooseAnOption);
            return;
        }

        const selectedTickets = [];
        let selectedTourName = "";
        let selectedHostInfo = "";

        // Add tour or WOW Intro based on selection
        if (selectedAddon === "tour") {
            selectedTickets.push({
                externalTicketCode: tourLanguageSelected,
                quantity: 1
            });
            
            // Determine the tour language name
            const tourLanguage = tourLanguageSelected === activeConfig.tour[`externalTicketCodeEN${suffix}`] 
                ? "Englisch" 
                : tourLanguageSelected === activeConfig.tour[`externalTicketCodeFR${suffix}`]
                    ? "Französisch"
                    : "Deutsch";
            selectedTourName = `WOW Insight (${tourLanguage})`;
        } else if (selectedAddon === "wowIntro") {
            selectedTickets.push({
                externalTicketCode: wowIntroLanguageSelected,
                quantity: 1
            });
            
            // Determine the WOW Intro language name
            const wowIntroLanguage = wowIntroLanguageSelected === activeConfig.WOWIntro[`externalTicketCodeEN${suffix}`]
                ? "Englisch"
                : wowIntroLanguageSelected === activeConfig.WOWIntro[`externalTicketCodeFR${suffix}`]
                    ? "Französisch"
                    : "Deutsch";
            selectedTourName = `WOW Intro (${wowIntroLanguage})`;
        }

        // Add Raum Vis a Vis if selected
        if (raumVisAVisSelected) {
            selectedTickets.push({
                externalTicketCode: raumVisAVisSelected,
                quantity: 1
            });
        }

        // Add visitor support if selected
        if (visitorSupportQuantity > 0) {
            selectedTickets.push({
                externalTicketCode: activeConfig.visitorSupport.externalTicketCode,
                quantity: visitorSupportQuantity
            });
            
            // Format host info for step60_information orderOption15
            selectedHostInfo = `${visitorSupportQuantity}`;
        }

        // Add guide if selected
        if (addGuideQuantity > 0) {
            selectedTickets.push({
                externalTicketCode: activeConfig.addGuide.externalTicketCode,
                quantity: addGuideQuantity
            });
        }

        // Save kombiTicket before proceeding (needed for the information page)
        // Store as "yes" or "no" based on whether it's selected
        localStorage.setItem("hasKombiTicket", kombiTicketSelected ? resources?._Yes : resources?._No);

        // Save selected tour name to localStorage for use in order options
        if (selectedTourName) {
            localStorage.setItem("selectedTourName", selectedTourName);
        } else {
            localStorage.removeItem("selectedTourName");
        }

        // Save selected host info to localStorage for use in order options
        if (selectedHostInfo) {
            localStorage.setItem("selectedHostInfo", selectedHostInfo);
        } else {
            localStorage.removeItem("selectedHostInfo");
        }

        //remove black tap milkshake from session (only used for birthday booking type)
        localStorage.removeItem("hasBlackTapMilkshake");

        // If "none" was selected and no visitor support or raum, or if no options available, remove add-ons
        if ((selectedAddon === "none" && visitorSupportQuantity === 0 && !raumVisAVisSelected) ||
            (!showTourOptions && visitorSupportQuantity === 0 && !raumVisAVisSelected)) {
            localStorage.removeItem('selectedTicketsAddons');
            navigate(`/${language}/calendar`);
            return;
        }

        const sessionData = {
            eventGroupId: 3553,
            tickets: selectedTickets
        };

        localStorage.setItem('selectedTicketsAddons', JSON.stringify(sessionData));
        navigate(`/${language}/calendar`);
    };

    const canProceed = true;

    // Check if tour options should be visible based on ticket count limit
    const showTourOptions = totalBookedTickets <= activeConfig.TicketsQuantitylimitToDisplay && !isHost;
    const hasAnyTourOptions = showTourOptions;

    // Check if any selected ticket has an external code containing "rally"
    const hasRallyTicket = selectedTicketsCrossSelling?.tickets?.some(ticket => 
        ticket.externalTicketCode?.toLowerCase().includes("rally")
    ) || false;

    // --- UI rendering ---
    // All config/price/ticket code logic is dynamic based on bookingType and ticket count
    return (
        <>
            <Header language={language} pagePath={`add-ons`} pageTitle={resources?.AddOnsTitle}
                ticketCount={order?.tickets?.length || 0} />

            <div className="page-container">
                <div className="container wrapper">

                    {/* Radio button section - Only show if there are tour options available */}
                    {hasAnyTourOptions && (
                        <>
                            <div className="row">
                                <p>
                                    <strong>
                                        {isHost
                                            ? `${resources?.AddOnsHost}`
                                            : `${resources?.AddOnsDesiredGuidedTour} *`
                                        }
                                    </strong>
                                </p>
                            </div>

                            {/* WOW Intro */}
                            <div className="row custom-box-with-border" style={{ marginLeft: "2px", marginRight: "2px" }}>
                                <table className="table table-no-border table-align-middle" style={{ marginBottom: 0 }}>
                                    <tbody>

                                        {/* WOW Intro radiobutton */}
                                        <tr>
                                            <td>
                                                <label style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                    <input
                                                        type="radio"
                                                        name="addon"
                                                        value="wowIntro"
                                                        checked={selectedAddon === "wowIntro"}
                                                        onChange={() => handleAddonChange("wowIntro")}
                                                    />
                                                    <span dangerouslySetInnerHTML={{ __html: resources?.AddOnsWowIntro }}></span>
                                                </label>
                                            </td>
                                            <td style={{ minWidth: "120px", textAlign: "right" }}>
                                                {/* Price is dynamically selected based on language and ticket count */}
                                                {wowIntroLanguageSelected === activeConfig.WOWIntro[`externalTicketCodeEN${suffix}`]
                                                    ? `CHF ${activeConfig.WOWIntro[`priceEN${suffix}`].toFixed(2)}`
                                                    : wowIntroLanguageSelected === activeConfig.WOWIntro[`externalTicketCodeFR${suffix}`]
                                                        ? `CHF ${activeConfig.WOWIntro[`priceFR${suffix}`].toFixed(2)}`
                                                        : `CHF ${activeConfig.WOWIntro[`priceDE${suffix}`].toFixed(2)}`
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2">
                                                <div style={{ marginLeft: 30 }}>
                                                    <span>{resources?.AddOnsWowIntroTourDesc}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        {/* WOW Intro language dropdownlist */}
                                        <tr>
                                            <td colSpan={3}>
                                                <div style={{ marginLeft: 30, marginTop: 2, marginBottom: 2, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                    <span>{resources?.AddOnsLanguage}:</span>
                                                    {/* Dropdown options are dynamically selected based on config and ticket count */}
                                                    <select
                                                        value={wowIntroLanguageSelected}
                                                        onChange={e => handleWowIntroLanguageDropdown(e.target.value)}
                                                        style={{ minWidth: 100, flexShrink: 0 }}
                                                        className="form-select language-select"
                                                        disabled={selectedAddon !== "wowIntro"}
                                                    >
                                                        <option value={activeConfig.WOWIntro[`externalTicketCodeDE${suffix}`]}>Deutsch</option>
                                                        <option value={activeConfig.WOWIntro[`externalTicketCodeEN${suffix}`]}>Englisch</option>
                                                        <option value={activeConfig.WOWIntro[`externalTicketCodeFR${suffix}`]}>Französisch</option>
                                                    </select>
                                                    <div className="info-icon-wrapper">
                                                        <img src={infoIcon} alt="Info" className="info-icon" />
                                                        <span className="tooltip">
                                                            {resources?.AddOnsWowIntroToolTip}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Tour */}
                            <div className="row mt-4 custom-box-with-border" style={{ marginLeft: "2px", marginRight: "2px" }}>
                                <table className="table table-no-border table-align-middle" style={{ marginBottom: 0 }}>
                                    <tbody>
                                        {/* Tour radiobutton */}
                                        <tr>
                                            <td>
                                                <label style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                    <input
                                                        type="radio"
                                                        name="addon"
                                                        value="tour"
                                                        checked={selectedAddon === "tour"}
                                                        onChange={() => handleAddonChange("tour")}
                                                    />
                                                    <span dangerouslySetInnerHTML={{ __html: resources?.AddOnsWowInsightTour }}></span>
                                                </label>
                                            </td>
                                            <td style={{ minWidth: "120px", textAlign: "right" }}>
                                                {/* Price is dynamically selected based on language and ticket count */}
                                                {tourLanguageSelected === activeConfig.tour[`externalTicketCodeEN${suffix}`]
                                                    ? `CHF ${activeConfig.tour[`priceEN${suffix}`].toFixed(2)}`
                                                    : tourLanguageSelected === activeConfig.tour[`externalTicketCodeFR${suffix}`]
                                                        ? `CHF ${activeConfig.tour[`priceFR${suffix}`].toFixed(2)}`
                                                        : `CHF ${activeConfig.tour[`priceDE${suffix}`].toFixed(2)}`
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2">
                                                <div style={{ marginLeft: 30 }}>
                                                    <span>{resources?.AddOnsWowInsightTourDesc}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        {/* Tour language dropdownlist */}
                                        <tr>
                                            <td colSpan={3}>
                                                <div style={{ marginLeft: 30, marginTop: 2, marginBottom: 2, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                    <span>{resources?.AddOnsLanguage}:</span>
                                                    {/* Dropdown options are dynamically selected based on config and ticket count */}
                                                    <select
                                                        value={tourLanguageSelected}
                                                        onChange={e => handleTourLanguageDropdown(e.target.value)}
                                                        style={{ minWidth: 100, flexShrink: 0 }}
                                                        className="form-select language-select"
                                                        disabled={selectedAddon !== "tour"}
                                                    >
                                                        <option value={activeConfig.tour[`externalTicketCodeDE${suffix}`]}>Deutsch</option>
                                                        <option value={activeConfig.tour[`externalTicketCodeEN${suffix}`]}>Englisch</option>
                                                        <option value={activeConfig.tour[`externalTicketCodeFR${suffix}`]}>Französisch</option>
                                                    </select>
                                                    <div className="info-icon-wrapper">
                                                        <img src={infoIcon} alt="Info" className="info-icon" />
                                                        <span className="tooltip">
                                                            {resources?.AddOnsWowInsightTourToolTip}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* No tour */}
                            <table className="mt-4 ms-3 table table-no-border table-align-middle" style={{ marginBottom: 0 }}>
                                <tbody>
                                    {/* No tour radiobutton */}
                                    <tr>
                                        <td>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                <input
                                                    type="radio"
                                                    name="addon"
                                                    value="none"
                                                    checked={selectedAddon === "none"}
                                                    onChange={() => handleAddonChange("none")}
                                                />
                                                <span>
                                                    {isHost ? resources?.AddOnsNoHost : resources?.AddOnsNoTour}
                                                </span>
                                            </label>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Error message */}
                            {errorMsg && (
                                <div className="custom-box text-red mt-3">{errorMsg}</div>
                            )}
                        </>

                        //{/* Add a Guide Section */}
                        //<div className="row">
                        //    <div className="col-md-12">
                        //       <hr className="ticket-separator" />
                        //   </div>
                        //</div>

                        //<table className="table table-no-border table-align-middle" style={{ marginBottom: 0, width: "100%" }}>
                        //    <tbody>
                        //        <tr>
                        //            <td>
                        //                <label style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        //                    <span>{resources?.AddOnsAddGuide}</span>
                        //                </label>
                        //            </td>
                        //            <td colSpan={2} style={{ width: "1%", paddingRight: "0" }}>
                        //                <div style={{
                        //                    display: "flex",
                        //                    justifyContent: "flex-end",
                        //                    alignItems: "center",
                        //                    gap: "2rem"
                        //                }}>
                        //                    <select
                        //                        className="form-select qtd-select"
                        //                        value={addGuideQuantity}
                        //                        onChange={e => setAddGuideQuantity(Number(e.target.value))}
                        //                    >
                        //                        {[...Array(activeConfig.addGuide.quantity + 1).keys()].map(qty => (
                        //                            <option key={qty} value={qty}>{qty}</option>
                        //                        ))}
                        //                    </select>
                        //                </div>
                        //            </td>
                        //        </tr>
                        //    </tbody>
                        //</table>

                    )}

                    {/* Host Section - Only show when totalBookedTickets >= TicketsQuantityNeededToDisplay */}
                    {totalBookedTickets >= activeConfig.visitorSupport.TicketsQuantityNeededToDisplay && (
                        <>
                            {hasAnyTourOptions && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <hr className="ticket-separator" />
                                    </div>
                                </div>
                            )}

                            <div className="row mt-2">
                                <p><strong>{resources?.AddOnsHost}</strong></p>
                            </div>

                            <div className="row custom-box-with-border" style={{ marginLeft: "2px", marginRight: "2px" }}>
                                <table className="table table-no-border table-align-middle" style={{ marginBottom: 0, width: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <label className="ps-4" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                    <strong>
                                                        <span>{resources?.AddOnsHostGroup}</span>
                                                    </strong>
                                                    <div className="info-icon-wrapper">
                                                        <img src={infoIcon} alt="Info" className="info-icon" style={{ marginLeft: 0 }} />
                                                        <span className="tooltip">
                                                            {resources?.AddOnsHostGroupToolTip}
                                                        </span>
                                                    </div>
                                                </label>
                                            </td>
                                            <td colSpan={2} style={{ width: "1%", paddingRight: "0" }}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                    gap: "2rem"
                                                }}>
                                                    <span style={{ minWidth: "120px", textAlign: "right" }}>
                                                        CHF {activeConfig.visitorSupport.price.toFixed(2)}
                                                    </span>
                                                    <select
                                                        className="form-select qtd-select"
                                                        value={visitorSupportQuantity}
                                                        onChange={e => setVisitorSupportQuantity(Number(e.target.value))}
                                                    >
                                                        {[...Array(activeConfig.visitorSupport.quantity + 1).keys()].map(qty => (
                                                            <option key={qty} value={qty}>{qty}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="row mt-4 ps-3 text-center">
                                    <p dangerouslySetInnerHTML={{ __html: resources?.AddOnsHostGroupDesc }}></p>
                                </div>
                            </div>
                        </>
                    )}

                    {/* Specials Section (Kombi-Ticket Museum & City Rally) - Only show when totalBookedTickets >= TicketsQuantityNeededToDisplay and no rally tickets */}
                    {totalBookedTickets >= activeConfig.visitorSupport.TicketsQuantityNeededToDisplay && !hasRallyTicket && (
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <hr className="ticket-separator" />
                                </div>
                            </div>

                            <div className="row mt-2">
                                <p><strong>{resources?.AddOnsKombiTicketTitle}</strong></p>
                            </div>

                            <div className="row custom-box-with-border" style={{ marginLeft: "2px", marginRight: "2px" }}>
                                <table className="table table-no-border table-align-middle" style={{ marginBottom: 0, width: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <label style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={kombiTicketSelected}
                                                        onChange={handleKombiTicketCheckbox}
                                                    />
                                                    <strong>
                                                        <span dangerouslySetInnerHTML={{ __html: resources?.AddOnsKombiTicket }}></span>
                                                    </strong>
                                                    <div className="info-icon-wrapper">
                                                        <img src={infoIcon} alt="Info" className="info-icon" style={{ marginLeft: 0 }} />
                                                        <span className="tooltip">
                                                            {resources?.AddOnsKombiTicketToolTip}
                                                        </span>
                                                    </div>
                                                </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="row mt-4 ps-3 text-center">
                                    <p dangerouslySetInnerHTML={{ __html: resources?.AddOnsKombiTicketDesc }}></p>
                                </div>
                            </div>
                        </>
                    )}

                    {/* Raum Vis a Vis Section - Only show when totalBookedTickets <= 20 and booking type is not schoolgroup */}
                    {activeConfig.raumVisAVis && totalBookedTickets <= activeConfig.raumVisAVis.TicketsQuantitylimitToDisplay && bookingType !== "schoolgroup" && (
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <hr className="ticket-separator" />
                                </div>
                            </div>

                            <div className="row mt-2">
                                <p><strong>{resources?.AddOnsGiftRaumVisAVisTitle}</strong></p>
                            </div>

                            <table className="table table-no-border table-align-middle" style={{ marginBottom: 0, width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td colSpan={2} style={{ padding: 0, border: 'none' }}>
                                            <div className="goodie-card">
                                                <div className="goodie-card-image">
                                                    <img src={activeConfig.raumVisAVis.image} alt="Raum vis a vis" />
                                                </div>
                                                <div className="goodie-card-content">
                                                    <div className="fw-bold">{resources?.AddOnsGiftRaumVisAVis}</div>
                                                    <div className="ps-md-4 pe-md-4 text-center" dangerouslySetInnerHTML={{ __html: resources?.AddOnsGiftRaumVisAVisDesc }}></div>
                                                    <div className="mt-3">
                                                        {raumVisAVisSelected && (
                                                            <span>
                                                                CHF {activeConfig.raumVisAVis.options.find(opt => opt.externalTicketCode === raumVisAVisSelected)?.price.toFixed(2)}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="goodie-select mt-3">
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                            <select
                                                                className="ms-md-4 form-select"
                                                                style={{ backgroundColor: "#fff", height: "35px", paddingTop: "4px", paddingBottom: "4px" }}
                                                                value={raumVisAVisSelected}
                                                                onChange={e => handleRaumVisAVisDropdown(e.target.value)}
                                                            >
                                                                <option value=""></option>
                                                                {activeConfig.raumVisAVis.options.map(option => (
                                                                    <option key={option.externalTicketCode} value={option.externalTicketCode}>
                                                                        {option.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <div className="info-icon-wrapper">
                                                                <img src={infoIconWhite} alt="Info" className="info-icon" style={{ marginLeft: 0 }} />
                                                                <span className="tooltip">
                                                                    {resources?.AddOnsRaumVisAVisToolTip}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    )}

                    <div className="row mt-5">
                        <div className="col-6">
                            <button
                                className="btn-custom white"
                                type="submit"
                                onClick={() => navigate(-1)}
                            >
                                {resources?._Back}
                            </button>
                        </div>

                        <div className="col-6 text-end">
                            <button
                                className="btn-custom"
                                type="submit"
                                onClick={handleNext}
                                disabled={!canProceed}
                            >
                                {resources?._Next}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Footer language={language} />
        </>
    );
}

export default Addons;